import type { IPromotion } from '../types';

import { create } from 'zustand';

interface PromotionStoreState {
  promotionsActive: IPromotion[] | null;
  isFetchedPromotionsActive: boolean;
}

interface PromotionStoreAction {
  setPromotionsActive: (value: IPromotion[]) => void;
  setIsFetchedPromotionsActive: (value: boolean) => void;
}

export const usePricingPromotionStore = create<PromotionStoreState & PromotionStoreAction>()(
  (set) => ({
    promotionsActive: null,
    isFetchedPromotionsActive: false,
    setPromotionsActive: (val: IPromotion[]) => {
      set(() => ({ promotionsActive: val }));
    },
    setIsFetchedPromotionsActive: (val: boolean) => {
      set(() => ({ isFetchedPromotionsActive: val }));
    },
  }),
);
